import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withModifiers as _withModifiers, vModelSelect as _vModelSelect, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("option", { value: "-1" }, "Selecciona un valor", -1 /* HOISTED */)
const _hoisted_2 = ["value"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return _withDirectives((_openBlock(), _createElementBlock("select", {
    onPointerdown: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop"])),
    onDblclick: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["stop"])),
    name: "mnlist",
    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.selectedData) = $event)),
    style: {"border":"1px solid #999","border-radius":"30px","font-size":"110%"},
    onChange: _cache[3] || (_cache[3] = ($event: any) => (_ctx.data.onChange(_ctx.selectedData))),
    class: "flex justify-content-center p-dropdown p-component p-inputwrapper p-inputwrapper-focus p-overlay-open w-full"
  }, [
    _hoisted_1,
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getMenuWithPath(), (mn, index) => {
      return (_openBlock(), _createElementBlock("option", {
        value: mn.id,
        key: index
      }, _toDisplayString(mn.path), 9 /* TEXT, PROPS */, _hoisted_2))
    }), 128 /* KEYED_FRAGMENT */))
  ], 544 /* HYDRATE_EVENTS, NEED_PATCH */)), [
    [_vModelSelect, _ctx.selectedData]
  ])
}